
import { state } from "@/store/modules/orders/state";
import mutations from "@/store/modules/orders/mutations"
import actions from "@/store/modules/orders/actions"
import getters from "@/store/modules/orders/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}